export default __webpack_public_path__ + "15c77f34361a2875ee243316ce959d85.png";